module.exports = __webpack_public_path__ + "img/citySelect2.ccbe5ef5.png";